import { Action } from '@ngrx/store';
import { RideArea } from '@polaris-customerweb/sharedcomponents.map';

export const RideAreaAction = {
    setActiveRideArea: '[ride area] set active ride area',
    setRideAreas: '[ride area] set ride areas',
    updateRideArea: '[ride area] update ride area',
};

export class SetActiveRideArea implements Action {
    type = RideAreaAction.setActiveRideArea;
    constructor(public rideArea: RideArea | undefined) {}
}

export class SetRideAreas implements Action {
    type = RideAreaAction.setRideAreas;
    constructor(public rideAreas: RideArea[]) {}
}

export class UpdateRideArea implements Action {
    type = RideAreaAction.updateRideArea;
    constructor(public rideArea: RideArea) {}
}
